<style>
    .head {

        background-color: rgb(245, 247, 250);
        color: rgb(102, 102, 102);
        padding: 20px 0px;
        font-size: 14px;
        font-weight: bold;
    }

    .row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        height: 60px;
    }

    .rows {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        height: 60px;
        color: #F56C6C;
        font-size: 18px !important;
    }

    .rows .detail {
        font-size: 18px !important;

    }

    .first_cos {
        width: 200px;
        padding-left: 20px;
        display: flex;
        align-items: center;
        font-weight: bold;
    }

    .detail {
        width: 70px;
        text-align: center;
        font-size: 14px;
        padding: 10px 0;
    }

    .row:nth-child(odd) {
        background-color: #f2f2f2;
    }

    .detail:last-child {
        color: #F56C6C;
        font-size: 18px;
    }

    .row img {
        width: 50px;
        height: 50px;
    }

    html, body, #app {
        min-width: 680px;
    }
</style>
<template>
    <div style="margin:10px 10px 0 10px;background-color: #EFF1F4;height: 100vh">
        <!--搜索-->
        <div class="el-card is-always-shadow" style="padding:20px 0 0 20px;margin-top: 10px;border-radius: 0">
            <el-form ref="searchForm" :model="search" size="mini" inline>
                <el-form-item label="销售区间" prop="name">
                    <!--                    <el-date-picker value-format="yyyy-MM-dd" v-model="search.day" type="daterange" range-separator="至"-->
                    <!--                                    start-placeholder="开始日期" end-placeholder="结束日期">-->
                    <!--                    </el-date-picker>-->

                    <el-date-picker
                            value-format="yyyy-MM-dd"
                            v-model="search.day"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-checkbox v-model="search.read">只读</el-checkbox>
                </el-form-item>
                <el-button type="primary" size="mini" @click="onSearch" icon="el-icon-search">查询</el-button>
            </el-form>
        </div>
        <div style="margin-top: 10px;height:calc(100vh - 165px);">
            <div style="padding: 10px;background-color: white" v-loading="loading" element-loading-text="拼命加载中">
                <div class="row head">
                    <div class="first_cos">商品</div>
                    <div class="detail" v-for="item in data1[0].store">{{item.name}}</div>
                </div>
                <div v-for="(item,index) in data1" :class="index<11?'row':'rows'">
                    <div class="first_cos" style="text-align: left;width: 200px">
                        <el-image v-if="item.id<11" :src="item.img" style="margin-right: 20px"></el-image>
                        {{item.name}}
                    </div>
                    <div class="detail" v-for="store in item.store">
                        <el-input v-if="update==0&&store.id>=0&&!search.read" v-model="store.number"
                                  style="width: 120px;font-weight: bold"
                                  @blur="onSubmit(item.id,store.id,store.number)" placeholder="请输入内容"></el-input>
                        <span v-else style="font-weight: bold">{{store.number}}</span>
                    </div>
                </div>
            </div>

        </div>
    </div>

</template>
<style>
    .el-row {
        display: flex;
    }
</style>
<script>
    import request from "../../plugins/axios";

    export default {
        data() {
            return {
                loading: false,
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近六个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                search: {
                    day: '',
                    read: false
                },
                data: [{store: []}],
                data1: [],
                update: 1
            };
        },
        components: {},
        created() {
            let that = this
            that.getUserData();
        },
        mounted() {
            let that = this
            that.getUserData();
        },
        methods: {
            onSubmit(product_id, store_id, number) {
                let that = this
                that.loading = true
                let writeForm = {
                    store_id: store_id,
                    product_id: product_id,
                    number: number,
                    day: that.search.day[0]
                }
                request({
                    url: "/hospital/News/sales_save",
                    data: writeForm,

                }).then((ret) => {
                    that.getUserData()
                });
            },

            //用户开始
            getUserData() {
                let that = this
                let data = that.search
                that.loading = true
                request({
                    url: "/hospital/News/sales1",
                    data: data,
                }).then((ret) => {
                    that.loading = false
                    if (ret.code == 1) {
                        that.data1 = ret.data.product
                        that.update = ret.data.update
                    }
                });
            },

            //用户查询
            onSearch() {
                this.getUserData();
            },

        },
    };
</script>
